import { gql } from "apollo-boost"

export const getBudgetSubmission = gql`
  query BudgetSubmission($id: ID!) {
    BudgetSubmission(id: $id) {
      state
      allies
      alliedOne
      alliedTwo
      status
      endDate
      region
      township
      startDate
      concepts {
        id
        isBlocking
        name
        index
        region
        type
        measurementUnit
        hours
        unitCost
        totalUnits
        monthlyDistribution
        monthlyDistributionHours
        budgeted
        deletedAt
        investmentDistribution {
          id
          name
          type
          percentage
        }
        humanResource {
          id
          position
          name          
          hours
          contractType          
          benefits                    
        }
      }
    }
  }
`